import { define, Model, AttributesMixin } from '@type-r/models'
import { localUserInfo } from './localUserInfo';
import { renameProperty } from './common';
import { getAuthToken } from './embedded-auth';
import { getPlatformCode } from 'src/app/pages/digitization/api/endpoint';

export interface Document extends AttributesMixin<typeof Document>{}
@define
export class Document extends Model {
    static attributes = {
        file_comments: "",
        file_name: "",
        file_path: "",
        upload_timestamp: Date,
        uploader: "",
        file_type: String,
        fileType: String,
        invoiceId: String,
        purchase_orders_id : String,
        user_id : String,
        userId: String,
        relationshipParticipantUserId: String,
        publishNutanixXml: Boolean,
        document_type: String,

        // WARN: we expect soon those to be named 'status'
        upload_po_status : String,
        uploadInvoiceStatus: String,
    }

    isPdf() : boolean {
        return Boolean( this.file_name && this.file_name.match( /\.pdf$/ ) );
    }

    async download(){
        const url = ( this.getEndpoint() as any ).getUrl( this ) + '/file';

        const response = await fetch( url, {
            method: 'GET',
            headers: new Headers({
                "Authorization": "Bearer " + getAuthToken(),
                "X-Platform-Code": getPlatformCode()
            })
        });

        const blob = await response.blob();

        const dataUrl = window.URL.createObjectURL(blob),
            a = document.createElement('a');

        a.href = dataUrl;
        a.download = this.file_name;
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();
        a.remove();  //afterwards we remove the element again
    }

    async save( options : { params : { comment : string, file } } ){
        const { file } = options.params;
        const url = ( this.getEndpoint() as any ).getUrl( this );
        const formData = new FormData();
        formData.append( "upfile", file, file.name );
        formData.append( "comment", this.file_comments );
        formData.append( "purchaseOrderId", this.purchase_orders_id );
        formData.append( "poStatus", this.upload_po_status );
        formData.append( "uploadInvoiceStatus", this.uploadInvoiceStatus );
        formData.append( "userId", this.user_id );
        formData.append( "relationshipParticipantUserId", this.relationshipParticipantUserId);
        formData.append( "custId", localUserInfo.organization_id );
        formData.append( "publishNutanixXml", this.publishNutanixXml ? "true" : "false");
        formData.append( "documentType", this.document_type);

        const response = await fetch( url, {
            method: 'POST',
            headers: new Headers({
                "Authorization": "Bearer " + getAuthToken(),
            }),
            body : formData
        });
        if( response.status === 413 ){
            throw new Error( 'File size must be less than 2MB' );
        }

        if( response.status < 200 || response.status >= 300 ){
            throw new Error( response.statusText || `HTTP Error ${response.status}` );
        }

        const json = await response.json();
        this.set( json );
        return this;
    }

    static collection = {
        comparator : x => -x.upload_timestamp.getTime()
    }

    parse(json: any): any {
        // TODO: remove this when the API is switched to support CamelCase properties names
        renameProperty(json, 'fileName', 'file_name');
        renameProperty(json, 'fileComments', 'file_comments');
        renameProperty(json, 'filePath', 'file_path');
        renameProperty(json, 'uploadTimestamp', 'upload_timestamp');
        renameProperty(json, 'purchaseOrderId', 'purchase_orders_id');
        renameProperty(json, 'documentType', 'document_type');
        return json;
    }
}
